module.exports = __webpack_public_path__ + "static/assets/fbbef73344d80136b4ba150032c2fa60.gif";